type InputFieldProps = {
    id: string;
    label: string;
    required?: boolean;
    disabled?: boolean;
    onChange?: (ev: Event) => any;
} & (
    | {
        ref?: HTMLInputElement;
        type: "text" | "date" | "password";
        value: string;
    }
    | {
        ref?: HTMLTextAreaElement;
        type: "textarea";
        value: string;
    }
    | {
        ref?: HTMLInputElement;
        type: "time"
        value: string;
        step?: string | number;
        min?: string | number;
        max?: string | number;
    }
    | {
        ref?: HTMLInputElement;
        type: "number"
        value: number;
        step?: string | number;
        min?: string | number;
        max?: string | number;
    }
    | {
        ref?: HTMLInputElement;
        type: "checkbox";
        value: boolean;
    }
);

export function InputField(props: InputFieldProps) {
    if (props.type === "checkbox") {
        return <div class="input-field-checkbox">
            <input
                ref={props.ref}
                type={props.type}
                id={props.id}
                disabled={props.disabled}
                onChange={props.onChange}
                checked={props.value ?? false}/>
            &nbsp;<label for={props.id}>{props.label}</label>
        </div>;
    }

    return <div class="input-field">
        <label for={props.id}>{props.label}{(props.required ?? false) ? <span class="obligatoire">*</span> : ""}</label>
        {(() => {
            switch (props.type) {
                case "time":
                case "number":
                    return <input
                        ref={props.ref}
                        type={props.type}
                        id={props.id}
                        step={props.step}
                        min={props.min}
                        max={props.max}
                        disabled={props.disabled}
                        onChange={props.onChange}
                        value={props.value.toString()}/>
                case "textarea":
                    return <textarea
                        ref={props.ref}
                        id={props.id}
                        disabled={props.disabled}
                        value={props.value}
                        onChange={props.onChange}></textarea>
                default:
                    return <input
                        ref={props.ref}
                        type={props.type}
                        id={props.id}
                        value={props.value}
                        disabled={props.disabled}
                        onChange={props.onChange}/>
            }
        })()}
    </div>;
}